import { render, staticRenderFns, recyclableRender, components } from "./success.vue?vue&type=template&id=d77f41e4&scoped=true&"
var renderjs
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=d77f41e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77f41e4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/success/success.vue"
export default component.exports